export default __webpack_public_path__ + "static/media/yzf-r15-v360a4a5958c528.c10c1e8e.webp";